import { Chip, Tabs } from '@medeloop/medeloop-components-library';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useGetOrganization, useGetOrganizationGeneralInfo } from 'src/api/organizations-queries';
import { NavigateBack, SkeletonLine, TitleSubTitle } from 'src/components';

const BASE_ORGANIZATIONAl_UNITS_URL = '/account/organizational-units';

export function OrganizationalUnitsDetailsPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { organizationId } = useParams();

  const { data, isLoading } = useGetOrganization(organizationId);
  const { data: orgGeneralInfo } = useGetOrganizationGeneralInfo(
    data?.organization.rootOrganizationId,
  );

  return (
    <section className="flex flex-col">
      <div className="h-52  bg-dark-subdued-background -mb-10 border-b border-stroke-on-dark-subdued">
        <div className="max-w-right-section mx-auto px-6 xl:px-0">
          <NavigateBack to={BASE_ORGANIZATIONAl_UNITS_URL} label="Organizational units" />
          <div className="flex items-center justify-between h-20">
            <TitleSubTitle
              title={data?.organization?.displayName ?? ''}
              subTitle={data?.organization?.name ?? ''}
              isLoading={isLoading}
            />
            <div className="flex gap-6 items-center">
              <div className="flex border rounded-md border-stroke-on-dark-subdued h-full w-80 p-4">
                <div className="flex gap-1 flex-col items-center justify-center pr-4 border-r border-stroke-on-dark-subdued">
                  {isLoading ? (
                    <div className="w-[80px]">
                      <SkeletonLine />
                    </div>
                  ) : (
                    <>
                      <span className="text-sm">Creation date</span>
                      <span className="text-content-on-dark-default">
                        {data?.organization.createdAt
                          ? new Date(data.organization.createdAt).toISOString().split('T')[0]
                          : ''}
                      </span>
                    </>
                  )}
                </div>
                <div className="flex gap-1 flex-col items-center justify-center pl-4">
                  {isLoading ? (
                    <div className="w-[150px]">
                      <SkeletonLine />
                    </div>
                  ) : (
                    <span className="text-content-on-dark-default">
                      <Chip
                        className="border-purple-200 text-purple-200"
                        text={orgGeneralInfo?.organization.displayName ?? ''}
                        disabled
                      />
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-right-section w-full mx-auto px-6 xl:px-0">
        <Tabs
          value={location.pathname.split('/').pop()}
          onValueChange={(value) =>
            navigate(`${BASE_ORGANIZATIONAl_UNITS_URL}/${organizationId}/${value}`)
          }
        >
          <Tabs.List className="border-b-0">
            <Tabs.Trigger value="researchers">
              Researchers ({data?.researchers.length ?? 0})
            </Tabs.Trigger>
            <Tabs.Trigger value="admins">Admins ({data?.admins.length ?? 0})</Tabs.Trigger>
            <Tabs.Trigger value="studies">Studies ({data?.studies.length ?? 0})</Tabs.Trigger>
            <Tabs.Trigger value="datasets">Datasets ({data?.dataSources.length ?? 0})</Tabs.Trigger>
          </Tabs.List>
          <Tabs.Content value="researchers">
            <Outlet />
          </Tabs.Content>
          <Tabs.Content value="admins">
            <Outlet />
          </Tabs.Content>
          <Tabs.Content value="studies">
            <Outlet />
          </Tabs.Content>
          <Tabs.Content value="datasets">
            <Outlet />
          </Tabs.Content>
        </Tabs>
      </div>
    </section>
  );
}
